import { useFormikContext } from 'formik';
import React, { FC } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { CanGoBack } from '../../models/CanGoBack';
import { SettingSummaryField } from '../settingFields/SettingSummaryField';
import { Button } from '../button/Button';

interface CustomFieldsSummaryFormProps extends CanGoBack {
}

export const CustomFieldsSummaryForm: FC<CustomFieldsSummaryFormProps> = ({ onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();
    const isRequired = values.required ? translate.byKey(TranslationKeys.yes) : translate.byKey(TranslationKeys.no)
    const isEnabled = values.enabled ? translate.byKey(TranslationKeys.yes) : translate.byKey(TranslationKeys.no)

    return <div className="pt-3 pr-3 h-full relative overflow-hidden" style={{ height: "501px" }}>
        <div className="flex flex-col overflow-auto" style={{ height: '87%' }}>
            <div >
                <SettingSummaryField accessor={"name"} displayName={translate.byKey(TranslationKeys.fieldName)}></SettingSummaryField>
            </div>
            <div >
                <SettingSummaryField accessor={"tooltip"} displayName={translate.byKey(TranslationKeys.toolTip)}></SettingSummaryField>
            </div>
            <div >
                <SettingSummaryField accessor={"required"} displayName={translate.byKey(TranslationKeys.required)} value={isRequired}></SettingSummaryField>
            </div>
            {values.newGroupName ? <div >
                <SettingSummaryField accessor={"newGroupName"} displayName={translate.byKey(TranslationKeys.group)} value={values.newGroupName}></SettingSummaryField>
            </div> : null}
            <div >
                <SettingSummaryField accessor={"enabled"} displayName={translate.byKey(TranslationKeys.enabled)} value={isEnabled}></SettingSummaryField>
            </div>
            <div >
                <SettingSummaryField accessor={values.newGroupName ? "newGroupName" : "masterGroupLabel"} displayName={translate.byKey(TranslationKeys.group)} value={values.newGroupName ? values.newGroupName : values.nmasterGroupLabel}></SettingSummaryField>
            </div>


        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5"
                    type="button" onClick={onBack}>
                    {translate.byKey(TranslationKeys.back)}
                </button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <Button
                    variant="submit"
                    shape="pill"
                    type="submit">
                    {translate.byKey(TranslationKeys.confirm)}
                </Button>
            </div>
        </div>
    </div>;
};
